export default "__VITE_ASSET__b6ca943d__"